import { render, staticRenderFns } from "./PromocodesSimpleList.vue?vue&type=template&id=5752ebcf&scoped=true"
import script from "./PromocodesSimpleList.vue?vue&type=script&lang=js"
export * from "./PromocodesSimpleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5752ebcf",
  null
  
)

export default component.exports